import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=a35cbdc8&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a35cbdc8')) {
      api.createRecord('a35cbdc8', component.options)
    } else {
      api.reload('a35cbdc8', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=a35cbdc8&", function () {
      api.rerender('a35cbdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Services.vue"
export default component.exports